export default [
  {
    path: "/teacher-dashboard",
    name: "teacher-main",
    component: () =>
      import("../../modules/Teachers/pages/TeacherDash/TeacherDash.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["teacher", "academy"],
    },
  },

  {
    path: "/group-attendance/:group_id",
    name: "group-attendance",
    component: () =>
      import(
        "../../modules/Teachers/pages/StudentsAttendance/StudentsAttendance.vue"
      ),
    meta: {
      auth: true,
      layout: "main",
      role: [
        "teacher",
        "instructor",
        "admin",
        "academy",
        "branchManager",
        "hunter",
        "finance",
        "kurator",
        "audit",
      ],
    },
  },

  {
    path: "/teacher-profile",
    name: "teacher-profile",
    component: () =>
      import("../../modules/Teachers/pages/TeacherProfile/TeacherProfile.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["teacher"],
    },
  },
  {
    path: "/extra-lessons",
    name: "extra-lessons",
    component: () =>
      import("../../modules/Teachers/pages/ExtraLessons/ExtraLessons.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["teacher"],
    },
  },
  {
    path: "/teacher-group/:group_id",
    name: "teacher-group",
    component: () =>
      import("../../modules/Teachers/pages/TeacherGroup/TeacherGroupPage.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["teacher", "academy", "admin"],
    },
  },
];
